<template>
    <div style="position:relative;">
        <!-- >>> Treeview Container -->
        <div
            ref="treeviewcontainerref"
            class="treeviewcontainer">
            <!-- >>> Dragbar -->
            <div
                v-if="!$isSmallDesktop()"
                ref="dragbarref"
                class="dragbar"
                :class="{hover: hoverDragbar}"
                @mouseover="hoverDragbar = true"
                @mouseleave="hoverDragbar = false" />
            <!-- <<< Dragbar -->
            <!-- >>> Treeview Header -->
            <sdr-selected-flight-list-header
                style="position:sticky;top:7px;z-index:2" />
            <!-- <<< Treeview Header -->

            <!-- >>> Treeview -->
            <v-treeview
                v-model="selectedFlights"
                :items="items"
                item-text="id"
                item-children="leaf"
                selection-type="leaf"
                return-object
                color="primary"
                transition
                selectable
                :open.sync="openIds"
                @input="onUpdateActive_filterSelectedFlight">
                <template v-slot:label="{ item }">
                    <sdr-selected-flight-list-item
                        style="padding-top: 7px;"
                        :layer="item.layer"
                        :item="item" />
                </template>
            </v-treeview>
            <!-- <<< Treeview -->
            <!-- >>> Dragbar -->
            <div
                v-if="$isSmallDesktop()"
                ref="dragbarref"
                class="dragbarBottom"
                :class="{hover: hoverDragbar}"
                @mouseover="hoverDragbar = true"
                @mouseleave="hoverDragbar = false" />
            <!-- <<< Dragbar -->
        </div>
        <!-- <<< Treeview Container -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import SelectedFlightListItem from './SelectedFlightListItem.vue';
    import SelectedFlightListHeader from './SelectedFlightListHeader.vue';
    import { eventBus } from '../../../../../../../main';



    export default {
        name: 'Selectedflightslist',
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-selected-flight-list-header': SelectedFlightListHeader,
            'sdr-selected-flight-list-item': SelectedFlightListItem

        },

        /* >>> *************************************************************** / /* Props */
        props: {
            onAssignUpdate: Function,
            filtered_selectedFlights: Array,
            preSelectedFlights: Array,
            openId: Array,
            selectedLayer: Number
        }, // eof components{}
        /* <<< *****************************************************************



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selectedFlights: [],
                // >>>>> Drag&Drop
                hoverDragbar: false,
                treeviewcontainerref: null,
                dragbarref: null,
                dragbarCurrentYPosition: 0
                // <<<<<
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_FlightTable_Rotations_Chain_Filtered'
            ]),

            openIds: {

                get() {

                    const me = this;

                    return me.openId;
                },

                set(val) {

                    const me = this;

                    return val;
                }
            },
            /***********************************************************************
            * computed::items
            *
            * Desc:
            * Note:
            *
            */
            items: {
                get() {

                    const me = this,
                          currentItems = [];


                    me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> get >>> items');
                    if (me.selectedLayer === 1) {
                        me.get_FlightTable_Rotations_Chain_Filtered.forEach(chain => {
                            if (me.filtered_selectedFlights.find(selectedFlight => selectedFlight.id === chain.id)) {
                                currentItems.push(chain);
                            }
                        });
                    } else if (me.selectedLayer === 2) {
                        me.get_FlightTable_Rotations_Chain_Filtered.forEach(chain => {
                            chain.children.forEach(rotation => {
                                if (me.filtered_selectedFlights.find(selectedFlight => selectedFlight.id === rotation.id)) {
                                currentItems.push(rotation);
                            }
                            });
                        });
                    } else if (me.selectedLayer === 1) {
                        me.get_FlightTable_Rotations_Chain_Filtered.forEach(chain => {
                            chain.children.forEach(rotation => {
                                rotation.children.forEach(leg => {
                                    if (me.filtered_selectedFlights.find(selectedFlight => selectedFlight.id === leg.id)) {
                                        currentItems.push(leg);
                                    }
                                });
                            });
                        });
                    }
                    return currentItems;
                },

                set(val) {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> get >>> items');
                    return val;
                }
             }

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {}, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> created');
            //eventBus.$on('flightsUpdated', me.onEmit_flightUpdated);

        }, // eo function created()



        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> mounted');
            me.onEmit_setDragAndDropListeners();
            me.onUpdateActive_filterSelectedFlight(me.preSelectedFlights);
            me.selectedFlights = me.preSelectedFlights;

        }, // eo function mounted()



        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> destroyed');
			//eventBus.$off('flightsUpdated', me.onEmit_flightUpdated);

        }, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([
                'actn_call_getLegsInfo'
            ]),

            /*******************************************************************
            * onUpdateActive_filterSelectedFlight()
            *
            * Desc:
            * Note:
            *
            */
            onUpdateActive_filterSelectedFlight: function (values) {

                const me = this;
                let firstSelectedFlight = null,
                    showWarning = false;


                me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> onUpdateActive_filterSelectedFlight');
                firstSelectedFlight = values[0];
                values = values.filter(value => {
                    if (value.layer === 2) {
                        return true;
                    } else {
                        return false;
                    }
                }); // don't know why this is needed?? but it is!
                values = values.filter(value => {
                    if (value.type === firstSelectedFlight.type) {
                        return true;
                    } else {
                        showWarning = true;
                        return false;
                    }
                });
                if (showWarning) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Selected flights must be of the same type of the first selected flight (DIRECT / VIA / TRIA, SINGLE / ROTATION)'
                    });
                    me.selectedFlights = values;
                }

                eventBus.$emit('rotationsselected', values);

            }, // eo function onUpdateActive_filterSelectedFlight()

            /*******************************************************************
            * onEmit_setDragAndDropListeners()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_setDragAndDropListeners: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> onEmit_setDragAndDropListeners');
                me.dragbarref = me.$refs.dragbarref;
                me.treeviewcontainerref = me.$refs.treeviewcontainerref;

                me.dragbarref.addEventListener('mousedown', function(e) {
                    me.dragbarCurrentYPosition = e.y;

                    document.addEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

                document.addEventListener('mouseup', function() {
                    // me.hoverDragbar = false;
                    document.removeEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

            }, // eo function onEmit_setDragAndDropListeners()


            /*******************************************************************
            * onEmit_resizeList()
            *
            * Desc: Calculates the new height of the Treeview Container
            * Note:
            *
            */
            onEmit_resizeList: function(e) {

                const me = this;
                const dragbarNewPosition =  e.y - me.dragbarCurrentYPosition;


                me.$toc('>>> views/flights/slotmanagement/components/core/flights/BottomSheet/SelectedFlightsList.vue >>> onEmit_resizeList');
                if (e.preventDefault) {                      // prevent selection while draggin
                    e.preventDefault();
                }
                if (e.y < 50 || e.y > 650) {
                    return;
                }
                me.hoverDragbar = true;
                me.dragbarCurrentYPosition = e.y;
                if (Vue.prototype.$isSmallDesktop()) {
                    me.treeviewcontainerref.style.maxHeight = (parseInt(getComputedStyle(me.treeviewcontainerref, '').maxHeight) + dragbarNewPosition) + 'px';
                    me.treeviewcontainerref.style.height = (parseInt(getComputedStyle(me.treeviewcontainerref, '').height) + dragbarNewPosition) + 'px';
                } else {
                    me.treeviewcontainerref.style.maxHeight = (parseInt(getComputedStyle(me.treeviewcontainerref, '').maxHeight) - dragbarNewPosition) + 'px';
                    me.treeviewcontainerref.style.height = (parseInt(getComputedStyle(me.treeviewcontainerref, '').height) - dragbarNewPosition) + 'px';
                }

            } // eo function onEmit_resizeList()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
.v-treeview-node:nth-child(2n+1) {
    background: rgb(244, 244, 244);
}

.v-treeview > .v-treeview-node--leaf {
    padding-left: 0px !important;
    margin-left: 0px !important;
    /* border-bottom: 1px solid grey */
}

.v-treeview-node__children {
    background: white;;
}

.vdatatable_test >>> .v-treeview-node__root {
    border-bottom: 1px solid grey;
}
</style>

<style scoped>

.treeviewcontainer {
    top:0;
    overflow-y: auto;
    height: 200px;
}

.dragbar {
    position:absolute;
    top:0;
    width:100%;
    height:7px;
    z-index:4;
    background-color:#e3b6cf;
    text-align:center;
    cursor:ns-resize;
}
.dragbarBottom {
    position:absolute;
    bottom:0;
    width:100%;
    height:7px;
    z-index:4;
    background-color:#e3b6cf;
    text-align:center;
    cursor:ns-resize;
}

.hover {
    height: 13px;
}


</style>
